import { getAdminDisplayName } from '../adminSession';

// 관리자가 '이력서 작성하기'로 작성한 이력서의 소유 계정 (회원 계정과 겹치지 않는 고정값)
export const ADMIN_RESUME_ACCOUNT = '__ministermore_admin__';

export function isAdminResume(userAccount: string) {
  return userAccount === ADMIN_RESUME_ACCOUNT;
}

export function adminResumeSignWriter() {
  const name = getAdminDisplayName();
  return name ? `관리자(${name})` : '관리자';
}
